import 'ui-core/widgets/raa/js/raa.js';
window.loadInstitutionPage = function (selectDom) {
    var href = $(selectDom).val();
    href = href.replace(/([&?]page=\d+)/, '');
    location.href = href;
};
